var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('log-list',{attrs:{"isLoading":_vm.isLoading,"list":_vm.dataPayment,"Model":_vm.getModel,"maxPreviewCount":4},on:{"onCreate":_vm.handleCreate,"onViewAll":_vm.handleViewAll}})}
var staticRenderFns = []

export { render, staticRenderFns }